import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {stepEnum, paymentAction} from '../Constants/debtPaymentEnum';
import {handleCurrentStep, selectSelectedBanData, selectServerData, selectEpiData} from '../DebtAndUpdatePaymentBlockSlice';
import Image from 'app/Components/Shared/Image/image';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';

const insightIcon = require('../images/insight.svg');

const CreditCardPayingEntityBanner = () => {
  const dispatch = useDispatch();
  const selectedBanData = useSelector(selectSelectedBanData);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const bansForUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);
  const paymentActionType = useSelector((state) => state.debtAndUpdatePayment.paymentAction);

  const handleClick = () => {
    if (paymentActionType === paymentAction.UPDATE_PAYMENT_METHOD) {
      dwhUpdatePaymentMethodReport({
        banData: selectedBanData,
        loginData,
        allBans,
        selectedBanNumbers: bansForUpdate,
        actionType: DwhActionType.CreditCardPage,
        messageText: DWHMessageText.PaymentEntityButtonClicked,
        status: DWHStatus.Ongoing,
        lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
      });
    }
    dispatch(handleCurrentStep(stepEnum.SENDSMSENTITYPAYMENT));
  };
  return (
    <div className='creditcard-step__paying-entity-banner'>
      <Image src={insightIcon} alt='' className='creditcard-step__paying-entity-banner__icon' />
      <p className='creditcard-step__paying-entity-banner__text'>
        רוצה לעדכן אשראי שלא שלך?{' '}
        <button type='button' className='creditcard-step__paying-entity-banner__link' onClick={() => handleClick()}>
          לעדכון
        </button>
      </p>
    </div>
  );
};

export default CreditCardPayingEntityBanner;
